import store from '../store'
import '../library/partnervip'
import userAgentHelper from './userAgentHelper';
import { getAuth } from "../mixins/authorize"

(function () {
  !function (e, t, n, g, i) {
    e[i] = e[i] || function () {
      (e[i].q = e[i].q || []).push(arguments)
    }, n = t.createElement('script')
    var tag = t.getElementsByTagName('script')[0]
    n.async = 1, n.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + g, tag.parentNode.insertBefore(n, tag)
  }(window, document, 'script', 'assets.giocdn.com/2.1/gio.js', 'gio')
  window.gio('init', 'aca7dc2ea0f02f49', {})
  window.gio('send')
  gioSet();
})();

let growingIo = {
  setUserId: '',  // 相当于1.x的CS1
  appSet: {},  // 相当于1.x的CS2 ~ CS10
  peopleSet: {},  // 相当于1.x的CS11 ~ CS20
  pageSet: {},  // 相当于1.x的PS
  gioItem: {
    medium: userAgentHelper.isAliMini() ? 'alipaymp' : (userAgentHelper.browser == 'ali' ? 'alipay' : (userAgentHelper.browser == 'weixin' ? 'wechat' : 'wap')),
    renting_status: getAuth().userId ? (getAuth().hasLease ? 'rented' : 'new') : 'unknown',
    facility_status: getAuth().userId ? (getAuth().isCredit ? 'yes' : 'no') : ''
  },
  initTrack(id, item) {
    let gioAlllItem = Object.assign({}, growingIo.gioItem, item)
    window.gio('track', id, gioAlllItem);
  },
  initPageSet(item) {
    let pageSetItem = Object.assign({}, growingIo.gioItem, item)
    window.gio('page.set', pageSetItem);
  }
};

function gioSet() {
  try {
    //  添加timer用于获取异步city数据
    let timer = null;
    let cityName = store.getters.currentCity.cityName;
    if (!cityName) {
      timer = setTimeout(() => {
        gioSet();
      }, 100);
      return;
    } else {
      clearTimeout(timer);
    }
    window.gio('setUserId', getAuth().userId || '');
    let appSet = {  //全局
      userId: getAuth().userId || '',
      usertype: getAuth().userId ? (getAuth().hasLease ? '是' : '否') : '',
      city: `${cityName}`
    };
    window.gio('app.set', appSet);
  } catch (ex) {
    console.log(ex);
  }
}

export default growingIo



// WEBPACK FOOTER //
// ./src/library/growingio.js